import ApiClient from "../aquaart-group";
import { NewsListResource, NewsResource } from "../generated-api";
import { NewsListRequestType } from "./types";

export class ApiNews {
  static async getNews(lang: string, params: NewsListRequestType): Promise<NewsListResource> {
    return ApiClient.get<NewsListResource>(`/news`, {
      page_size: 6,
      page_number: params.pageNumber,
    });
  }

  static async getDetailNews(lang: string, id: number): Promise<NewsResource> {
    return ApiClient.get<NewsResource>(`/news/${id}`);
  }
}
